import { Box } from '@mui/material';
import { Fragment, ReactNode } from 'react';
import {
  StatColumn,
  StatDivider,
  StatLabel,
  StatsTileBody,
  StatsTileFooter,
  StatsTileHeader,
  StatsTileSection,
  StatsTileTitle,
  StatValue,
} from './styles';

export interface StatsTileItem {
  key: string;
  label: string;
  value: ReactNode;
  labelColor?: string;
  valueColor?: string;
}

export interface StatsTileProps {
  title: string;
  titleAdornment?: ReactNode;
  stats: StatsTileItem[];
  headerSlot?: ReactNode;
  footerSlot?: ReactNode;
  headerBackground?: string;
  headerTextColor?: string;
  height?: string;
}

const StatsTile = (props: StatsTileProps): JSX.Element => {
  const { title, titleAdornment, stats, headerSlot, footerSlot, headerBackground, headerTextColor, height } = props;
  return (
    <StatsTileSection tileHeight={height}>
      <StatsTileHeader headerBackground={headerBackground} headerTextColor={headerTextColor}>
        <Box display="flex" alignItems="center" gap="6px">
          <StatsTileTitle>{title}</StatsTileTitle>
          {titleAdornment}
        </Box>
        {headerSlot}
      </StatsTileHeader>
      <StatsTileBody>
        {stats.map((stat, index) => (
          <Fragment key={stat.key}>
            {index > 0 && <StatDivider />}
            <StatColumn>
              <StatLabel labelColor={stat.labelColor}>{stat.label}</StatLabel>
              <StatValue valueColor={stat.valueColor}>{stat.value}</StatValue>
            </StatColumn>
          </Fragment>
        ))}
      </StatsTileBody>
      {footerSlot && <StatsTileFooter>{footerSlot}</StatsTileFooter>}
    </StatsTileSection>
  );
};

StatsTile.defaultProps = {
  titleAdornment: undefined,
  headerSlot: undefined,
  footerSlot: undefined,
  headerBackground: undefined,
  headerTextColor: undefined,
  height: undefined,
};

export default StatsTile;
